import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ArchivosService } from './api/archivos.service';
import { ConsultaDeDocumentosService } from './api/consultaDeDocumentos.service';
import { InfoPersonaService } from './api/infoPersona.service';
import { IngestaDeDocumentosService } from './api/ingestaDeDocumentos.service';
import { ParametrosService } from './api/parametros.service';
import { RoutingRuleManagementControllerService } from './api/routingRuleManagementController.service';
import { RuleManagementControllerService } from './api/ruleManagementController.service';
import { SolicitudControllerService } from './api/solicitudController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ArchivosService,
    ConsultaDeDocumentosService,
    InfoPersonaService,
    IngestaDeDocumentosService,
    ParametrosService,
    RoutingRuleManagementControllerService,
    RuleManagementControllerService,
    SolicitudControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
